import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link, BrowserRouter as Router, Route } from "react-router-dom";
import "./style.scss";
import "../style.scss";
import { Helmet } from "react-helmet";
import { toolsCalculate, cornerSectionOverview } from "../actions";
import { getRouting } from "../../../../../utils/common";

const LearnersTools = (props) => {
  const {
    toolsCalculate,
    toolsCalculateData,
    cornerSectionOverview,
    cornerOverviewList,
  } = props;

  const [calsi, setcalsi] = useState();
  const [metaData, setMetaData] = useState("");

  const [cornerOverviewTab, setcornerOverviewTab] = useState("");

  useEffect(() => {
    !(cornerOverviewList && cornerOverviewList.cornerOverview) && cornerSectionOverview();
  }, []);

  useEffect(() => {
    if (cornerOverviewList && cornerOverviewList.cornerOverview) {
      setcornerOverviewTab(cornerOverviewList.cornerOverview);
    }
  }, [cornerOverviewList]);

  useEffect(() => {
    !(toolsCalculateData && toolsCalculateData.toolsCalculator) && toolsCalculate();
  }, []);

  useEffect(() => {
    if (toolsCalculateData && toolsCalculateData.toolsCalculator) {
      setcalsi(toolsCalculateData.toolsCalculator);
    }
    if (toolsCalculateData.toolsCalculator && toolsCalculateData.toolsCalculator.meta) {
      setMetaData(toolsCalculateData.toolsCalculator.meta)
    }
  }, [toolsCalculateData]);

  //dropdown start

  const [dropdown, setdropdown] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropDown = () => {
    setdropdown(!dropdown);
  };

  const handleClickOut = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setdropdown(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOut);
    return () => {
      document.removeEventListener("click", handleClickOut);
    };
  }, [dropdown]);

  //dropdown end

  return (
    <div className="wrapper">
     
      {metaData && metaData !== null && <Helmet>
              <title>{metaData.title ? metaData.title : ""}</title>
              <meta name="description" content={metaData.description ? metaData.description : ""} />
              <meta name="keywords" content={metaData.keywords ? metaData.keywords : ""} />
              <meta property="og:title" content={metaData.og_title ? metaData.og_title : ""} />
              <meta property="og:description" content={metaData.og_description ? metaData.og_description : ""} />
              <meta property="og:image" content={metaData.og_image ? metaData.og_image : ""} />
              <meta property="og:url" content={metaData.og_url ? metaData.og_url : ""} />
            </Helmet>}

      <section className="aboutHead">
        <div className="container">
          <div className="d-flex dropdowncls">
            <div class="dropdown me-auto" ref={dropdownRef}>
              <div id="dropdownMenuLink" onClick={toggleDropDown}>
                <h1>
                  <span>Calculators</span>
                  <img
                    className="ms-2"
                    src="/images/New/redDownArrow.svg"
                    alt="arrow"
                  />
                </h1>
              </div>
                            {dropdown && (
                <ul class="dropdown-body" aria-labelledby="dropdownMenuLink">
                  {cornerOverviewTab &&
                    cornerOverviewTab.length > 0 &&
                    cornerOverviewTab.map((over, index) =>
                      over.linkName != "Calculators" ? (
                        <li>
                          <a
                            class="dropdown-item fw-bold"
                            href={over.linkName == 'Quiz' ? over.linkUrl : over.routeConstant}
                          >
                            {over.linkName}
                          </a>
                        </li>
                      ) : null
                    )}
                </ul>
              )}
            </div>
            <nav
              aria-label="breadcrumb"
              className="align-self-center breadCrumbCust d-md-inlin"
            >
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li className="breadcrumb-item d-flex active breadcolor">
                  Calculators
                </li>
                {/* <li className="breadcrumb-item active breadcolor" aria-current="page"></li> */}
              </ol>
            </nav>
          </div>
        </div>
      </section>
      <section className="tools">
        <div className="container">
          <div className="row my-5 gx-5">
            {calsi &&
              calsi.calculatorScreens &&
              calsi.calculatorScreens.map((tools, index) => {
                return (
                  <div className="col-lg-4 mb-4">
                    <div className="card p-0" key="index">
                      <div className="cardHead p-4 d-flex">
                        <div>
                          <img src={tools.attributes.class} alt="" />
                        </div>
                        <div className="ms-3">
                          <h2>{tools.linkName}</h2>
                          <p className="subheading">{tools.linkDescription}</p>
                        </div>
                      </div>
                      <div className="cardFooter p-4">
                        <Link
                          to={getRouting(tools.routeConstant)}
                          className="readMore1"
                        >
                          <p className="">Calculate</p>
                        </Link>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </section>
    </div>
  );
};

const mapStateToProps = (state) => ({
  toolsCalculateData: state.LearnsCorners,
  cornerOverviewList: state.LearnsCorners,
});

const mapDispatchToProps = (dispatch) => ({
  toolsCalculate: bindActionCreators(toolsCalculate, dispatch),
  cornerSectionOverview: bindActionCreators(cornerSectionOverview, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(LearnersTools);
